import { render, staticRenderFns } from "./NewsFeedCard.vue?vue&type=template&id=86386c74&"
import script from "./NewsFeedCard.vue?vue&type=script&lang=js&"
export * from "./NewsFeedCard.vue?vue&type=script&lang=js&"
import style0 from "./NewsFeedCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewsFeedCard.vue"
export default component.exports